/**
 * Builds the multipart FormData for POST /v1/historical-orders/create from a
 * field object shaped like AddCompletedOrder's `data` state (or a resolved
 * bulk-upload row) — both use the same field names by design, so this one
 * function serves both the single-order form and the per-row bulk submit.
 */
import { SAMPLE_PHOTO_FIELDS } from "./fieldDefs";

export default function buildHistoricalOrderFormData(fields) {
  const fd = new FormData();
  const append = (key, value) => { if (value !== undefined && value !== null && value !== "") fd.append(key, value); };

  append("notificationEmail", fields.notificationEmail);
  append("companyId", fields.company);
  append("projectCodeId", fields.projectCode);
  append("agencyId", fields.agency);
  append("commodityId", fields.commodity);
  append("packageId", fields.package);
  append("sampleVariant", fields.sampleVariant);
  append("sampleType", fields.sampleType);
  append("sector", fields.sector);
  append("stateName", fields.state);
  append("districtName", fields.district);
  append("samplerName", fields.sampler);
  append("siteAddress", fields.siteAddress);
  append("batchId", fields.batchId);
  append("supplier", fields.supplier);
  append("quantity", fields.quantity);
  append("quantityUnit", fields.quantityUnit);
  append("notes", fields.notes);
  fd.append("purchaseDetails", JSON.stringify({
    nameOfTheShop: fields.nameOfShop, addressOfTheShop: fields.addressOfShop, dateOfPurchase: fields.dateOfPurchase,
    quantityOfSample: fields.sampleWeight, costOfSample: fields.sampleCost, typeOfShop: fields.typeOfShop,
  }));
  append("sampleSealNo", fields.sampleSealNo);
  append("qrCodeId", fields.qrCodeId);
  append("samplePackedIn", fields.samplePackedIn);
  append("fssaiLogoPresent", fields.fssaiLogoPresent);
  append("vegSymbolPresent", fields.vegSymbolPresent);
  append("assignedLabId", fields.assignedLab);
  append("assignedLogisticsId", fields.assignedLogistics);
  append("trackingId", fields.trackingId);
  fd.append("sampleAcceptance", JSON.stringify({
    samplePhysicalCondition: fields.samplePhysicalCondition, conditionOfSeal: fields.conditionOfSeal,
    sampleRegistrationNumber: fields.sampleRegistrationNumber || undefined,
    expectedDateOfCompletion: fields.expectedDateOfCompletion,
  }));
  fd.append("stageDates", JSON.stringify({
    pendingDate: fields.pendingDate, bookedDate: fields.bookedDate, inReviewDate: fields.inReviewDate,
    readyForPickupDate: fields.readyForPickupDate, outForPickupDate: fields.outForPickupDate,
    deliveredToLabDate: fields.deliveredToLabDate, receivedAtLabDate: fields.receivedAtLabDate,
    underTestingDate: fields.underTestingDate, reportUploadedDate: fields.reportUploadedDate,
  }));
  append("targetEndStatus", fields.targetEndStatus);
  append("completedDate", fields.completedDate);
  fd.append("compliance", JSON.stringify({
    overallSafetyCompliant: fields.overallSafetyCompliant, overallQualityCompliant: fields.overallQualityCompliant,
    overallLabellingCompliant: fields.overallLabellingCompliant, overallSampleClassification: fields.overallSampleClassification,
  }));
  if (fields.reportFile) fd.append("reportFile", fields.reportFile);
  if (fields.reportMetadataFile) fd.append("reportMetadataFile", fields.reportMetadataFile);
  // Every optional SampleDetails photo — field name matches
  // be/utils/uploadFile.js's HISTORICAL_ORDER_SAMPLE_PHOTO_FIELDS exactly, so
  // this covers all of them without naming each one individually. Genuinely
  // optional: appended only when actually attached.
  SAMPLE_PHOTO_FIELDS.forEach((field) => { if (fields[field]) fd.append(field, fields[field]); });
  return fd;
}
